import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { GiftAuditModalPage } from './gift-audit-modal.page';

const routes: Routes = [
  {
    path: '',
    component: GiftAuditModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [GiftAuditModalPage]
})
export class GiftAuditModalPageModule {}
